<template>
  <div>...</div>
</template>

<script>
export default {
  name: 'Login',

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$sso.login()
    })
  }
}
</script>
